
export const awsmobile = {
    aws_appsync_graphqlEndpoint: "https://eg6tpscayrc6tdpga72xhjmzai.appsync-api.ap-southeast-1.amazonaws.com/graphql",
    aws_appsync_region: "ap-southeast-1",
    aws_appsync_authenticationType: "AMAZON_COGNITO_USER_POOLS",
    aws_cognito_region: "ap-southeast-1",
    aws_user_pools_id: "ap-southeast-1_oun72jXsB",
    aws_user_pools_web_client_id: "5gj6bsj30hhsbqg1sglblu26s1",
    preview_domain: "auth.traderflowtest.com",
    sso_redirect_uri: "https://app.traderflowtest.com/",
    aws_user_pool_domain: "traderflowtest-sso.auth.ap-southeast-1.amazoncognito.com",
    competition_bucket_url: "https://tf-api-competitionsbucket89235cd2-4chhi8x76obf.s3.ap-southeast-1.amazonaws.com",
    websocket_url: "wss://hja67b032a.execute-api.ap-southeast-1.amazonaws.com/prod",
    forex_copilot_api_url: "",
    oauth: {
        domain: "traderflowtest-sso.auth.ap-southeast-1.amazoncognito.com",
        scope: ["email", "openid", "profile"],
        redirectSignIn: "https://app.traderflowtest.com/",
        redirectSignOut: "https://app.traderflowtest.com/",
        responseType: "code"
    },
    federationTarget: "COGNITO_USER_POOLS",
    aws_cognito_social_providers: ["FACEBOOK", "GOOGLE", "APPLE"]
};
export default awsmobile;

